// import store from '@/store';
export default {
  items:{
    area:{
      title:'Регион / район'
    },
    city:{
      title:'Город / н.п.'
    },
    street:{
      title:'Улица'
    },
    house:{
      title:'Дом'
    },
    deportament:{
      title:'Квартира'
    },
  }
}
